import React, { Dispatch, FC, SetStateAction } from 'react';
import { ReactComponent as AddReaction } from 'assets/icons/AddReaction.svg';
import { StyledRelWrap, StyledWrap } from './styled';

interface ReactionQuickButtonProps {
  entityId: string;
  isDark?: boolean;
  isReactionButtonMenuShown?: boolean;
  setIsReactionButtonMenuShown?: Dispatch<SetStateAction<boolean>>;
  isReactionMenuOpened?: boolean;
  className?: string;
  setReactionCoordinates?: (coords: { x: number; y: number }) => void;
}

const ReactionQuickButton: FC<ReactionQuickButtonProps> = ({
  entityId,
  isDark,
  isReactionButtonMenuShown,
  setIsReactionButtonMenuShown,
  isReactionMenuOpened,
  className,
  setReactionCoordinates,
}) => {
  const handleButtonClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (isReactionMenuOpened) {
      return;
    }

    const rect = e.currentTarget.getBoundingClientRect();
    const coordinates = {
      x: rect.left + rect.width / 2,
      y: rect.top - 10, // Position above the button
    };

    setReactionCoordinates?.(coordinates);
    setIsReactionButtonMenuShown?.(true);
  };

  return (
    <StyledRelWrap>
      <StyledWrap
        className={className}
        isDark={!!isDark}
        isToolTipShown={!!isReactionButtonMenuShown}
        data-tooltip-id={entityId}
        data-tooltip-place="top"
        onClick={handleButtonClick}
      >
        <div>
          <AddReaction viewBox="0 0 24 24" height={24} width={24} />
        </div>
      </StyledWrap>
    </StyledRelWrap>
  );
};

export default ReactionQuickButton;
